function Logo() {
  return (
    <img
      src="/icons/UsmaApp.png"
      alt="UsmaApp Logo"
      loading="lazy"
      style={{
        width: "140px",
        height: "auto",
        objectFit: "contain",
        display: "block",
        borderRadius: "8px",
      }}
    />
  );
}

export default Logo;
